import { api, ReactQueryOptions } from '@api';
import { handleSendTriggerClient } from '@specs/helpers';
import { CartInputBody } from '@specs/specs';
import { useShowToast } from '@hooks/useShowToast';
import { addToysToCart, getToysInCartFromCookies, ICartItemToys } from '../helpers/cart';
type optionsType = ReactQueryOptions['StoreManager']['cartCheckout'];
export const useBuyToy = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    onError,
    onSuccess,
    onSettled
  } = options ?? {};
  const {
    mutateAsync
  } = api.StoreManager.cartCheckout.useMutation({
    mutationKey: ['StoreManager.cartCheckout'],
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
      const list = getToysInCartFromCookies();
      const selectedStoreItems = new Set(variables.cart.map(({
        storeItemId
      }) => storeItemId));
      const newCartList = list.map(item => {
        const figures = item.figures.filter(figure => !selectedStoreItems.has(figure.storeItemId));
        return figures.length > 0 ? {
          ...item,
          figures
        } : null;
      }).filter(Boolean) as ICartItemToys[];
      addToysToCart(newCartList);
    },
    onSettled: (data, error, variables, context) => {
      onSettled?.(data, error, variables, context);
      handleSendTriggerClient('Purchase Confirmation');
    },
    ...options
  });
  const buyHandler = async (cart: CartInputBody) => await mutateAsync({
    cart
  });
  return {
    buyHandler
  };
};